module.exports = __webpack_public_path__ + "static/media/valk-cadeaucard-number.02aa137c.png";